import { render, staticRenderFns } from "./step-btns.vue?vue&type=template&id=387f0b5a&scoped=true&"
import script from "./step-btns.vue?vue&type=script&lang=js&"
export * from "./step-btns.vue?vue&type=script&lang=js&"
import style0 from "./step-btns.vue?vue&type=style&index=0&id=387f0b5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387f0b5a",
  null
  
)

export default component.exports